export default __webpack_public_path__ + "static/media/ttk.cfbe6393.png";